<div class="page-layout-container">
  <form [formGroup]="yearlyForm">
    <div class="row">
      <div class="col-6" style="padding: 20px 0 0 20px;width: 80%; margin-right: 30px">
        <app-emp-name [filterEmpName]="filterEmpName" (empName)="empNameSelected($event)" formControlName="name">
        </app-emp-name>
      </div>
      <div class="col">
        <mat-form-field>
          <mat-label>Select year for generating report</mat-label>
          <input matInput [matDatepicker]="selectedYear" required [formControl]="selectedY">
          <mat-datepicker-toggle matSuffix [for]="selectedYear"></mat-datepicker-toggle>
          <mat-datepicker #selectedYear></mat-datepicker>
      </mat-form-field>
      </div>
      <div class="col">
        <button mat-button (click)="getYearlyTimesheet(selectedY.value)">
          Fetch Year Leaves
        </button>
      </div>
      <div class="col" *ngIf="employeeData !== null">
            <button mat-button (click)="downloadYearlyTimesheet(selectedY.value)">
              Download Employee Yearly Leaves Report
            </button>
      </div>
    </div>
  </form>

  <!--*ngIf="employeeData !== null" -->
  <div *ngIf="employeeData !== null" class="main-container" id="yearly-timesheet">

    <div class="row">
      <div class="col-2" style="color:#4a148c;font-family: Helvetica, Arial, sans-serif;font-size: 1rem;">
        RTT Leaves = {{rttLeaves}}
      </div>
      <div class="col-2" style="color:#4a148c;font-family: Helvetica, Arial, sans-serif;font-size: 1rem;">
        Auth Leaves = {{authLeaves}}
      </div>
      <div class="col-2" style="color:#4a148c;font-family: Helvetica, Arial, sans-serif;font-size: 1rem;">
        Other Leaves = {{otherLeaves}}
      </div>
      <div class="col-2" style="color:#4a148c;font-family: Helvetica, Arial, sans-serif;font-size: 1rem;">
        Compensation Leaves = {{compensationLeaves}}
      </div>
      <div class="col-2" style="color:#4a148c;font-family: Helvetica, Arial, sans-serif;font-size: 1rem;">
        Forwarded Leaves = {{forwardedLeaves}}
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="flex-container flex-center" style="margin: 20px 0 40px 0">
          <button (click)="previousMonth()" class="iconsSize ml-1 my-auto" mat-icon-button>
            <mat-icon>
              chevron_left
            </mat-icon>
          </button>
          <button (click)="nextMonth()" class="iconsSize ml-1 my-auto" mat-icon-button>
            <mat-icon>
              chevron_right
            </mat-icon>
          </button>
          <h5 class="icon-font">{{date.format('YYYY ')}}</h5>
        </div>
        <div *ngFor="let calendarItem of calendar; let i = index">
          <div class="flex-container">
            <div *ngIf="i>0" class="calendar-month position-relative">
              <span>{{calendarItem[0] !== undefined ? calendarItem[0].monthName : ''}}</span>
            </div>
            <div *ngFor="let day of calendarItem" [class.weekend]="day.isWeekend" [ngClass]="day.className"
              class="calendar-days year-calendar-days position-relative">
              <div *ngIf="day.monthName === 'Jan'" class="weekday-title">{{day.day}}</div>
              {{day.employeeData}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" id="divList">
      <div *ngFor="let leave of leaveList" class="d-flex" id="divContent">
        <div [ngClass]="leave.className" class="square"></div>
        <p class="pl-10 leaveList">{{leave.name}}</p>
      </div>
    </div>
  </div>
  <app-progress [loading$]="loading$"> </app-progress>
</div>